import * as React from 'react'
import * as st from './circlePlayButton.module.scss'
import { tryCatch } from '../../utils/tryCatch'
import { getPlaybackClickstreamRef } from '../../utils/getPlaybackClickstreamRef'
import { RecordRefTag } from '../recordReftag/recordReftag'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PlayButton } from '../playButton/PlayButton'
import * as cn from 'classnames'

export interface ICirclePlayButtonProps {
  playbackData?: WpsRuntime.atv.wps.PlaybackActionDataProps
  sessionId: string,
  pageTitleId: string,
  isPackshot?: boolean
}

export const CirclePlayButton = tryCatch(({playbackData, sessionId, pageTitleId, isPackshot}: ICirclePlayButtonProps) => {

  if (!playbackData) {
    return null
  }

  const deeplinkingData = {
    fallbackUrl: playbackData.fallbackURL,
    titleId: playbackData.playbackID,
    resumeTime: playbackData.resumeTime,
    signInUrl: playbackData.signInURL,
    sessionId,
    pageTitleId,
    ref: getPlaybackClickstreamRef(playbackData.contentType, playbackData.entitlementType),
    videoType: playbackData.videoMaterialType
  }

  const classNames = cn(
    st.imagePlayButton,
    isPackshot ? st.packshotButton : undefined
  )


  return (
    <RecordRefTag refTag="atv_dp_pb_circle">
      <PlayButton
        deepLinkingData={deeplinkingData}
        className={classNames}
        href={playbackData.playbackURL}
        isSeeThrough
        isPackshotButton={isPackshot}
      />

    </RecordRefTag>
  )
})
